export const TAB_OPTIONS = [
  { value: 'profile', label: 'Profile', icon: 'solar:user-id-bold' },
  { value: 'transaction', label: 'Transaction', icon: 'solar:card-transfer-bold' },
  { value: 'policy', label: 'Policy', icon: 'solar:shield-warning-bold' },
  { value: 'controls', label: 'Controls', icon: 'solar:shield-user-bold' },
  { value: 'bank-accounts', label: 'Bank Accounts', icon: 'solar:card-recive-bold' },
  { value: 'beneficiaries', label: 'Beneficiaries', icon: 'solar:card-recive-bold' },
  { value: 'referrals', label: 'Referrals', icon: 'solar:users-group-rounded-bold' },
  { value: 'invites', label: 'Invites', icon: 'solar:letter-bold' },
  { value: 'security', label: 'Security', icon: 'solar:lock-password-bold' },
  { value: 'devices', label: 'Devices', icon: 'solar:smartphone-2-bold' },
];

export const createModuleState = () => ({
  loading: false,
  loaded: false,
  error: null,
  data: null,
});
